<template>
  <div class="my-lessons" :class="[singleTopic ? 'singleTopicStyle' : '']">
    <Return
      v-if="!singleTopic"
      :returnData="{
        title: 'تالار گفتگو',
        path: 'showForum',
      }"
    />
    <div v-if="!singleTopic" class="divider"></div>
    <div class="calendarBox f_s_b col-12" :class="[singleTopic ? 'h-100' : '']">
      <div
        v-if="data.id"
        class="calendar p-0 f_s_s f-d-c"
        :class="[singleTopic ? 'col-12-custom' : 'col-7-custom']"
      >
        <div
          v-if="
            data.day_for_forum_cutoffdate == 0 ||
            data.day_for_forum_cutoffdate < 0
          "
          class="f_c_s cutofdate"
        >
          تاریخ پایانی برای ارسال پست در این انجمن به پایان رسیده است، بنابراین
          دیگر نمی توانید در آن پست ارسال کنید.
        </div>
        <div v-if="data.day_for_forum_duedate == 0" class="f_c_s cutofdate">
          مهلت ارسال برای پست کردن مطلب در این تالارگفتگو تا
          {{ data.duedate }}
          است.
        </div>
        <div class="description f_s_s f-d-c w-100">
          <div class="post f_s_s f-d-c w-100 p-2">
            <div class="headerSection f_c_s w-100 mb-2">
              <b-img
                class="ml-2"
                :src="require(`@/assets/images/footer-icon/forum/user.svg`)"
                fluid
              ></b-img>
              <div class="subject-time f_s_s f-d-c">
                <div class="subject">
                  موضوع تالار :
                  {{
                    data.subject || data.name ? data.subject || data.name : "-"
                  }}
                </div>
                <div class="time" v-if="data.person || data.date">
                  از
                  <span class="c00aa82">{{
                    data.person ? data.person : "-"
                  }}</span>
                  در
                  {{ data.date ? data.date : "-" }}
                </div>
              </div>
            </div>
            <div class="content mb-2" v-html="data.html"></div>
            <div v-if="data.file.length" class="file mb-2 f-w-w">
              <b-img
                class="ml-2"
                :src="
                  require(`@/assets/images/footer-icon/myticket/paperclip-blue.svg`)
                "
                fluid
              ></b-img>
              <a
                v-for="(f, j) in data.file"
                :key="j"
                :href="f.url"
                class="ml-2"
                >{{ f.name }}</a
              >
            </div>
            <div
              v-if="data.day_for_forum_cutoffdate > 0"
              class="answer f_b_s f-d-c w-100"
            >
              <textarea v-model="form.textarea" class="pl-2 pr-2"> </textarea>
              <div class="answerSection w-100 f_c_b">
                <div class="answerBtn" @click.prevent="sendAnswerFunc(data)">
                  ارسال پاسخ
                </div>
                <b-form-group id="fileInputForum" class="dragdrop m-0">
                  <b-form-file
                    multiple
                    class="forumFile"
                    placeholder="ارسال فایل"
                    drop-placeholder="رها کنید"
                    @input="addFileFunc"
                  >
                    <template slot="placeholder">
                      <div class="text">ارسال فایل</div>
                    </template>
                    <template slot="file-name">
                      <div class="text">ارسال فایل</div>
                    </template>
                  </b-form-file>
                </b-form-group>
              </div>
              <div v-if="form.file.length" class="fileList f_c_s f-w-w">
                <div
                  class="fileList-item f_c_c"
                  v-for="(v, i) in form.file"
                  :key="i"
                >
                  <span
                    class="close-btn ml-2"
                    @click.prevent="deleteFileFunc(i)"
                    >&times;</span
                  >
                  <a :href="v.link ? v.link : '#'" class="value">{{
                    v.name
                  }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btnSection f_c_s w-100 mb-2">
          <div
            v-if="data.viewScore"
            class="viewScoreBtn"
            @click.prevent="viewScoreFunc()"
          >
            مشاهده نمره
          </div>
        </div>
        <div class="posts f_e_s f-d-c w-100">
          <div
            v-for="(v, i) in data.posts"
            :key="i"
            class="post f_s_s f-d-c w-95 p-2"
            :class="[v.parent_id ? '' : 'd-none']"
            :id="v.id"
          >
            <div class="headerSection f_c_s w-100 mb-2">
              <b-img
                class="ml-2"
                :src="require(`@/assets/images/footer-icon/forum/user.svg`)"
                fluid
              ></b-img>
              <div class="subject-time f_s_s f-d-c">
                <div class="subject">
                  در پاسخ به :
                  {{ v.parent_name ? v.parent_name : "-" }}
                </div>
                <div class="time" v-if="v.start_user || v.start_date">
                  از
                  <span class="c1d9dae">{{ v.start_user }}</span>
                  در
                  {{ v.start_date }}
                </div>
              </div>
            </div>
            <div class="content mb-2" v-html="v.html"></div>
            <div v-if="v.file.length" class="file f_c_s f-w-w">
              <b-img
                class="ml-2"
                :src="
                  require(`@/assets/images/footer-icon/myticket/paperclip-blue.svg`)
                "
                fluid
              ></b-img>
              <div v-for="(f, j) in v.file" :key="j" class="borderLeftFile">
                <a :href="f.url" class="ml-2">{{ f.name }}</a>
              </div>
            </div>
            <div class="answer f_c_e w-100">
              <b-img
                v-if="v.can_replay"
                class="ml-2"
                @click.prevent="replyForumFunc(v)"
                :src="
                  require(`@/assets/images/footer-icon/forum/${
                    replySelect == v.id ? 'greenReply' : 'reply'
                  }.svg`)
                "
                fluid
              ></b-img>
              <b-img
                v-if="v.edit"
                class="ml-2"
                @click.prevent="editForumFunc(v)"
                :src="require(`@/assets/images/footer-icon/forum/edit.svg`)"
                fluid
              ></b-img>
              <b-img
                v-if="v.delete"
                @click.prevent="deleteForumFunc(v)"
                :src="require(`@/assets/images/footer-icon/forum/delete.svg`)"
                fluid
              ></b-img>
            </div>
            <div
              v-if="replySelect == v.id && issendanswertopic"
              class="replySection f_s_s w-100 mt-2"
            >
              <div class="answer f_b_s f-d-c w-100">
                <textarea v-model="replyForm.textarea" class="pl-2 pr-2">
                </textarea>
                <div class="answerSection w-100 f_c_b">
                  <div
                    class="answerBtn"
                    @click.prevent="sendAnswerTopicFunc(v)"
                  >
                    ارسال پاسخ
                  </div>
                  <b-form-group id="fileInputForum" class="dragdrop m-0">
                    <b-form-file
                      multiple
                      class="forumFile"
                      placeholder="ارسال فایل"
                      drop-placeholder="رها کنید"
                      @input="addReplyFileFunc"
                    >
                      <template slot="placeholder">
                        <div class="text">ارسال فایل</div>
                      </template>
                      <template slot="file-name">
                        <div class="text">ارسال فایل</div>
                      </template>
                    </b-form-file>
                  </b-form-group>
                </div>
                <div v-if="replyForm.file.length" class="fileList f_c_s">
                  <div
                    class="fileList-item f_c_c ml-2"
                    v-for="(v, i) in replyForm.file"
                    :key="i"
                  >
                    <span
                      class="close-btn ml-2"
                      @click.prevent="deleteReplyFileFunc(i)"
                      >&times;</span
                    >
                    <a :href="v.link ? v.link : '#'" class="value">{{
                      v.name
                    }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="spinner f_c_c" v-else>
        <b-spinner
          type="grow"
          variant="success"
          label="Loading..."
          class="blueSpinner"
        ></b-spinner>
      </div>
      <div v-if="!singleTopic" class="task-class col-3 p-0 f_c_sa">
        <b-img
          class="lesson-class-icon"
          :src="require(`@/assets/images/footer-icon/forum/forum-icon.svg`)"
          fluid
        ></b-img>
      </div>
    </div>
    <b-modal
      id="deleteTask-modal"
      title="توجه"
      button-size="sm"
      :hide-footer="footer"
      ref="delTask-modal"
    >
      <template class="content f_s_s">
        <div>
          <h5>آیا از حذف گفتگو اطمینان دارید؟</h5>
        </div>
        <div class="footerBtn f_c_e">
          <b-button id="searchBtn" @click="deleteForumItemFunc()">حذف</b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="editForum-modal"
      title="ویرایش"
      button-size="sm"
      size="lg"
      @hidden="editModalHide"
      :hide-footer="footer"
      ref="editForum-modal"
    >
      <template class="content f_s_s">
        <div
          contenteditable="true"
          class="textarea"
          v-html="selectForEdit.html"
          @input="changeTextareaValueFunc"
        ></div>
        <div class="answer f_b_s f-d-c w-100">
          <div class="answerSection w-100 f_c_b">
            <div class="answerBtn" @click.prevent="sendEditAnswerFunc()">
              ارسال پاسخ
            </div>
            <b-form-group id="fileInputForum" class="dragdrop m-0">
              <b-form-file
                multiple
                class="forumFile"
                placeholder="ارسال فایل"
                drop-placeholder="رها کنید"
                @input="addEditFileFunc"
              >
                <template slot="placeholder">
                  <div class="text">ارسال فایل</div>
                </template>
                <template slot="file-name">
                  <div class="text">ارسال فایل</div>
                </template>
              </b-form-file>
            </b-form-group>
          </div>
          <div v-if="formEdit.file" class="fileList f_s_s">
            <div
              class="fileList-item f_c_c"
              v-for="(v, i) in formEdit.file"
              :key="i"
            >
              <b-img
                class="ml-2"
                :src="
                  require(`@/assets/images/footer-icon/myticket/paperclip-blue.svg`)
                "
                fluid
              ></b-img>
              <a :href="v.link ? v.link : '#'" class="value ml-3">{{
                v.name
              }}</a>
              <span
                class="close-btn ml-2"
                @click.prevent="deleteEditFileFunc(v, i)"
                >&times;</span
              >
            </div>
          </div>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="editForum-modal"
      body-class="viewScoreFunc-modal"
      title="مشاهده نمره"
      button-size="sm"
      :hide-footer="footer"
      ref="viewScoreFunc-modal"
    >
      <template class="f_s_s f-d-c w-100">
        <div v-if="gradeInfo.grade" class="specifications f_c_b fn-09rem">
          <div class="f_s_s f-d-c c1d9dae">
            <div class="f_c_c mb-1">نمره :</div>
            <div class="f_c_c mb-1">نمره داده شده توسط :</div>
            <div class="f_c_c mb-1">تاریخ :</div>
            <div class="f_c_c">وضعیت نمره :</div>
          </div>
          <div class="f_e_s f-d-c c006e7f">
            <div class="f_c_c mb-1">{{ gradeInfo.grade_info }}</div>
            <div class="f_c_c mb-1">{{ gradeInfo.grade_from }}</div>
            <div class="f_c_c mb-1">{{ gradeInfo.grade_date }}</div>
            <div class="f_c_c">
              {{ gradeInfo.grade_status ? "نمره داده شده" : "نمره داده نشده" }}
            </div>
          </div>
        </div>
        <div v-else class="specifications f_c_c noScore">
          نمره ای وارد نگردیده است.
        </div>
        <div v-if="gradeInfo.grade" class="score f_c_c fn-2rem c1d9dae">
          {{ gradeInfo.grade }}
        </div>
        <div class="modalDivider"></div>
        <div class="btnSection w-100 f_c_c">
          <div
            class="f_c_c border1d9dae c1d9dae"
            @click.prevent="viewScoreCancel()"
          >
            انصراف
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import mixin from "@/mixins/mixin";
import Return from "@/components/button/Return.vue";
export default {
  mixins: [mixin],
  name: "NewsForum",
  data() {
    return {
      footer: true,
      editMode: false,
      selectForDelete: {},
      selectForEdit: {},
      form: {
        file: [],
        textarea: "",
      },
      replyForm: {
        file: [],
        textarea: "",
      },
      formEdit: {
        file: [],
        textarea: "",
      },
      data: {},
      replySelect: null,
      size: 0,
      isTopic: false,
      selectPost: {},
      indexForDeleteFile: null,
      formEditAdd: [],
      selectForEditItemid: null,
      selectForEditId: null,
      isreply: false,
      isedit: false,
      editAddFile: false,
      isdelete: false,
      isdeletesecond: false,
      issendanswertopic: false,
    };
  },
  created() {},
  computed: {
    ...mapState({
      loginStates: (state) => state.login,
      heightWidthValue: (state) => state.login.heightWidthValue,
      forumDetails: (state) => state.my.forumDetails,
      showAnswerData: (state) => state.my.showAnswerData,
      forumDelete: (state) => state.my.forumDelete,
      returnsectionId: (state) => state.my.returnsectionId,
      itemId: (state) => state.my.itemId,
      forumAnswerStatus: (state) => state.my.forumAnswerStatus,
      forumEditAnswerStatus: (state) => state.my.forumEditAnswerStatus,
      deleteStatus: (state) => state.my.deleteStatus,
      editForumItemId: (state) => state.my.editForumItemId,
      discussionReturnData: (state) => state.my.discussionReturnData,
      forumEditDeleteStatus: (state) => state.my.forumEditDeleteStatus,
      gradeInfo: (state) => state.my.gradeInfo,
    }),
    user() {
      return this.loginStates.user;
    },
  },
  components: { Return },
  props: ["singleTopic", "singleTopicData"],
  methods: {
    ...mapActions("my", [
      "prevUrlFunction",
      "deleteForumFunction",
      "getForumDetailsFunction",
      "uploadFileFunction",
      "sendForumAnswerFunction",
      "editFileDeletedFunction",
      "uploadEditFileFunction",
      "sendForumEditAnswerFunction",
      "showAnswerFunction",
      "checkEditDeletePostFunction",
    ]),
    changeTextareaValueFunc(e) {
      this.formEdit.textarea = e.target.innerText;
    },
    viewScoreFunc() {
      this.$refs["viewScoreFunc-modal"].show();
    },
    viewScoreCancel() {
      this.$refs["viewScoreFunc-modal"].hide();
    },
    generalFileUploadFunc(e, v, form) {
      let accept = [".pdf", ".jpg", ".doc", ".docx"];
      if (
        form.file.length == parseInt(v.maxattach) ||
        form.file.length + e.length > parseInt(v.maxattach)
      ) {
        this.$bvToast.toast(
          "تعداد فایلهای ارسالی بیش از " +
            this.toFarsiNumber(v.maxattach) +
            " فایل است.",
          {
            title: "خطا در تعداد فایل",
            variant: "danger",
            solid: true,
          }
        );
      } else {
        for (let i = 0; i < e.length; i++) {
          let regArr = e[i].name.split(".");
          let reg = "." + regArr[regArr.length - 1];
          if (accept.includes(reg)) {
            let value = parseInt(e[i].size);
            let maxVolum = this.bytesToSize(v.maxbytes).split(" ");
            if (
              this.size < parseInt(v.maxbytes) &&
              this.size + value < parseInt(v.maxbytes)
            ) {
              form.file.push(e[i]);
              if (this.editAddFile) {
                this.formEditAdd.push(e[i]);
              }
              this.size = this.size + value;
            } else {
              this.$bvToast.toast(
                "حجم فایلهای ارسالی بیش از" +
                  parseInt(maxVolum[0]) +
                  this.setVolumUnit(maxVolum[1]) +
                  " می باشد. ",
                {
                  title: "خطا در حجم فایل",
                  variant: "danger",
                  solid: true,
                }
              );
            }
          } else {
            this.$bvToast.toast(
              "پسوند فایل ارسالی باید یک از این پسوند ها " +
                accept.toString() +
                " باشد.",
              {
                title: "خطا در پسوند فایل",
                variant: "danger",
                autoHideDelay: 7000,
                solid: true,
              }
            );
          }
        }
      }
    },
    generalSendAnswerFunc(v, form) {
      if (form.file.length == 0 && form.textarea == "") {
        this.$bvToast.toast("پاسخی ارسال نشده است.", {
          title: "خطا در ارسال پاسخ",
          variant: "danger",
          solid: true,
        });
      } else {
        if (form.file.length > 0) {
          this.uploadFileFunction({
            wstoken: this.user.token,
            file: form.file,
          });
        } else {
          this.sendForumAnswerFunction({
            wstoken: this.user.token,
            postid: v.posts ? v.posts[0].id : v.id,
            subject: this.data.name,
            message: form.textarea,
            attachmentsid: 0,
          });
        }
      }
    },
    sendAnswerFunc(v) {
      this.isTopic = false;
      this.generalSendAnswerFunc(v, this.form);
    },
    sendAnswerTopicFunc(v) {
      this.isTopic = true;
      this.selectPost = v;
      this.generalSendAnswerFunc(v, this.replyForm);
    },
    sendEditAnswerFunc() {
      if (this.formEdit.file.length == 0 && this.formEdit.textarea == "") {
        this.$bvToast.toast("پاسخی ارسال نشده است.", {
          title: "خطا در ارسال پاسخ",
          variant: "danger",
          solid: true,
        });
      } else {
        this.selectForEditItemid =
          this.formEdit.file.length && this.formEdit.file[0].itemid
            ? this.formEdit.file[0].itemid
            : null;
        if (this.formEditAdd.length > 0 && this.selectForEditItemid) {
          this.uploadEditFileFunction({
            wstoken: this.user.token,
            file: this.formEditAdd,
            itemId: this.selectForEditItemid,
          });
        } else {
          if (this.formEditAdd.length > 0) {
            this.editMode = true;
            this.uploadFileFunction({
              wstoken: this.user.token,
              file: this.formEditAdd,
            });
          } else {
            if (this.selectForEditItemid) {
              this.sendForumEditAnswerFunction({
                wstoken: this.user.token,
                postid: this.selectForEditId,
                subject: this.data.name,
                message: this.formEdit.textarea,
                attachmentsid: this.selectForEditItemid,
              });
            } else {
              this.sendForumEditAnswerFunction({
                wstoken: this.user.token,
                postid: this.selectForEditId,
                subject: this.data.name,
                message: this.formEdit.textarea,
                attachmentsid: 0,
              });
            }
          }
        }
      }
      this.$refs["editForum-modal"].hide();
    },
    addFileFunc(e) {
      this.generalFileUploadFunc(e, this.data, this.form);
    },
    addReplyFileFunc(e) {
      this.generalFileUploadFunc(e, this.data, this.replyForm);
    },
    addEditFileFunc(e) {
      this.editAddFile = true;
      this.generalFileUploadFunc(e, this.data, this.formEdit);
    },
    editForumFunc(v) {
      for (let i = 0; i < v.file.length; i++) {
        this.size = this.size + v.file[i].filesize;
      }
      this.isedit = true;
      this.isdelete = false;
      this.isreply = false;
      this.checkEditDeletePostFunction({
        wstoken: this.user.token,
        discussion: v.id,
      });
      this.selectForEdit = v;
      this.selectForEditId = v.id;
      this.formEdit.file = v.file;
      this.formEdit.textarea = v.html;
    },
    deleteForumFunc(v) {
      this.isdelete = true;
      this.isreply = false;
      this.isedit = false;
      this.checkEditDeletePostFunction({
        wstoken: this.user.token,
        discussion: v.id,
      });
      this.selectForDelete = v;
    },
    replyForumFunc(v) {
      this.replyForm.file = [];
      this.replyForm.textarea = "";
      this.isreply = true;
      this.isdelete = false;
      this.isedit = false;
      this.checkEditDeletePostFunction({
        wstoken: this.user.token,
        discussion: v.id,
      });
      if (this.replySelect == v.id) {
        this.replySelect = null;
        this.issendanswertopic = false;
      } else {
        this.replySelect = v.id;
      }
    },
    deleteFileFunc(i) {
      this.form.file.splice(i, 1);
    },
    deleteReplyFileFunc(i) {
      this.replyForm.file.splice(i, 1);
    },
    deleteEditFileFunc(v, i) {
      let index = this.formEdit.file.length - this.formEditAdd.length;
      if (v.itemid) {
        this.indexForDeleteFile = i;
        this.editFileDeletedFunction({
          wstoken: this.user.token,
          filename: v.name,
          itemid: v.itemid,
        });
      } else {
        this.formEdit.file.splice(i, 1);
        this.formEditAdd.splice(index, 1);
      }
    },
    deleteForumItemFunc() {
      this.isdeletesecond = true;
      this.isdelete = false;
      this.isreply = false;
      this.isedit = false;
      this.checkEditDeletePostFunction({
        wstoken: this.user.token,
        discussion: this.selectForDelete.id,
      });
    },
    editModalHide() {
      this.size = 0;
      this.showAnswerFunction({
        wstoken: this.user.token,
        discussionid: this.discussionReturnData.discussionid,
        id: this.discussionReturnData.id,
      });
      // this.getForumDetailsFunction({
      //   wstoken: this.user.token,
      //   courseid: this.returnsectionId.courseid,
      //   forumid: this.returnsectionId.forumid,
      // });
      this.editMode = false;
      this.editAddFile = false;
    },
  },
  watch: {
    itemId: function (n) {
      if (this.isTopic) {
        this.sendForumAnswerFunction({
          wstoken: this.user.token,
          postid: this.selectPost.id,
          subject: this.data.name,
          message: this.replyForm.textarea,
          attachmentsid: n,
        });
      } else {
        if (this.editMode) {
          this.sendForumEditAnswerFunction({
            wstoken: this.user.token,
            postid: this.selectForEditId,
            subject: this.data.name,
            message: this.formEdit.textarea,
            attachmentsid: n,
          });
        } else {
          this.sendForumAnswerFunction({
            wstoken: this.user.token,
            postid: this.data.posts[0].id,
            subject: this.data.name,
            message: this.form.textarea,
            attachmentsid: n,
          });
        }
      }
    },
    forumAnswerStatus(n) {
      this.size = 0;
      if (n.errorcode == "nopostforum") {
        this.$bvToast.toast(n.message, {
          title: "توجه",
          variant: "danger",
          solid: true,
        });
      } else {
        this.$bvToast.toast(n.messages[1].message, {
          title: "توجه",
          variant: "warning",
          solid: true,
        });
        this.$bvToast.toast(n.messages[0].message, {
          title: "ارسال پاسخ",
          variant: "success",
          solid: true,
        });
        if (this.isTopic) {
          this.replyForm.textarea = "";
          this.replyForm.file = [];
          this.replySelect = null;
        } else {
          this.form.textarea = "";
          this.form.file = [];
        }
        if (this.forumDetails.type == 5) {
          this.getForumDetailsFunction({
            wstoken: this.user.token,
            courseid: this.returnsectionId.courseid,
            forumid: this.returnsectionId.forumid,
          });
        } else {
          this.showAnswerFunction({
            wstoken: this.user.token,
            discussionid: this.discussionReturnData.discussionid,
            id: this.discussionReturnData.id,
          });
        }
      }
    },
    forumEditAnswerStatus(n) {
      this.size = 0;
      if (n) {
        this.$bvToast.toast("پست با موفقیت ویرایش گردید.", {
          title: "ویرایش",
          variant: "success",
          solid: true,
        });
        // this.getForumDetailsFunction({
        //   wstoken: this.user.token,
        //   courseid: this.returnsectionId.courseid,
        //   forumid: this.returnsectionId.forumid,
        // });
        this.showAnswerFunction({
          wstoken: this.user.token,
          discussionid: this.discussionReturnData.discussionid,
          id: this.discussionReturnData.id,
        });
        this.formEdit.textarea = "";
        this.formEdit.file = [];
        this.editMode = false;
        this.selectForEdit = {};
        this.formEditAdd = [];
        this.selectForEditItemid = null;
        this.selectForEditId = null;
        this.editAddFile = false;
      }
    },
    deleteStatus(n) {
      if (n) {
        this.$bvToast.toast("فایل با موفقیت حذف گردید.", {
          title: "حذف فایل",
          variant: "success",
          solid: true,
        });
        this.formEdit.file.splice(this.indexForDeleteFile, 1);
      }
    },
    editForumItemId(n) {
      this.sendForumEditAnswerFunction({
        wstoken: this.user.token,
        postid: this.selectForEditId,
        subject: this.data.name,
        message: this.formEdit.textarea,
        attachmentsid: n[0].itemid,
      });
    },
    singleTopicData(n) {
      this.data = n;
    },
    forumDetails(n) {
      this.data = n;
    },
    forumDelete(n) {
      if (n) {
        this.getForumDetailsFunction({
          wstoken: this.user.token,
          courseid: this.returnsectionId.courseid,
          forumid: this.returnsectionId.forumid,
        });
      }
    },
    forumEditDeleteStatus(n) {
      if (Object.keys(n).length) {
        if (this.isreply && n.can_replay) {
          this.issendanswertopic = true;
        }
        if (this.isedit) {
          if (n.can_edite) {
            this.$refs["editForum-modal"].show();
          } else {
            this.getForumDetailsFunction({
              wstoken: this.user.token,
              courseid: this.returnsectionId.courseid,
              forumid: this.returnsectionId.forumid,
            });
            this.$bvToast.toast("زمان برای ویرایش به پایان رسیده است.", {
              title: "حذف فایل",
              variant: "danger",
              solid: true,
            });
          }
        }
        if (this.isdelete) {
          if (n.can_delete) {
            this.$refs["delTask-modal"].show();
          } else {
            this.getForumDetailsFunction({
              wstoken: this.user.token,
              courseid: this.returnsectionId.courseid,
              forumid: this.returnsectionId.forumid,
            });
            this.$bvToast.toast("زمان برای حذف به پایان رسیده است.", {
              title: "حذف فایل",
              variant: "danger",
              solid: true,
            });
          }
        }
        if (this.isdeletesecond) {
          if (n.can_delete) {
            this.deleteForumFunction({
              wstoken: this.user.token,
              id: this.selectForDelete.id,
            });
            this.$refs["delTask-modal"].hide();
          } else {
            this.getForumDetailsFunction({
              wstoken: this.user.token,
              courseid: this.returnsectionId.courseid,
              forumid: this.returnsectionId.forumid,
            });
            this.$bvToast.toast("زمان برای حذف به پایان رسیده است.", {
              title: "حذف فایل",
              variant: "danger",
              solid: true,
            });
          }
        }
      }
    },
    showAnswerData(n) {
      this.data = n;
    },
  },
  mounted() {
    this.setHeight(this.heightWidthValue);
    if (this.singleTopicData) {
      this.data = this.singleTopicData;
    } else {
      this.data = this.showAnswerData;
    }
  },
  beforeDestroy: function () {
    this.prevUrlFunction("forum");
  },
};
</script>
<style lang="scss" scoped>
.my-lessons {
  height: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 0.2rem 1rem;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  .calendarBox {
    padding: 0 10px;
    height: 80%;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
    .calendar {
      height: 100%;
      overflow: auto;
      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
      .cutofdate {
        background-color: #d1edfe;
        padding: 2px 15px;
        border-radius: 5px;
        font-weight: bold;
        color: #4c5064;
        margin-bottom: 10px;
      }
      .title {
        .text {
          color: #1d9dae;
          font-size: 18px;
          font-weight: bold;
        }
      }
      .description {
        margin-bottom: 0.5rem;
        .post {
          border: 1px solid #cecece;
          border-radius: 10px;
          height: fit-content;
          min-height: 130px;
          overflow: auto;
          .headerSection {
            .subject {
              font-size: 0.95rem;
              font-weight: bold;
              color: #006e7f;
            }
            .time {
              color: #3d3d3d;
              font-size: 0.9rem;
            }
          }
          .content {
            color: #707070;
          }
          .file {
            img {
              width: 1rem;
            }
            a {
              color: #1d9dae;
            }
          }
          .answer {
            textarea {
              resize: none;
              width: 100%;
              height: 10vh;
              border: 1px solid #1d9dae;
              border-radius: 7px;
              -webkit-transition: all 1s -0.25s ease-out;
              -moz-transition: all 1s -0.25s ease-out;
              -o-transition: all 1s -0.25s ease-out;
              -ms-transition: all 1s -0.25s ease-out;
              transition: all 1s -0.25s ease-out;
              z-index: 999;
              &:focus {
                outline: none;
                -webkit-transition: all 1s ease;
                -moz-transition: all 1s ease;
                -o-transition: all 1s ease;
                -ms-transition: all 1s ease;
                transition: all 1s ease;
              }
            }
            .answerSection {
              .answerBtn {
                background-color: #1d9dae;
                color: white;
                border-radius: 15px;
                font-weight: bold;
                padding: 0px 20px 3px 20px;
                cursor: pointer;
              }
            }
            .fileList {
              height: 30px;
              width: 100%;
              flex-wrap: wrap;
              overflow: auto;
              .fileList-item {
                .close-btn {
                  font-size: 20px;
                  font-weight: bold;
                  color: #eb0404;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
      .btnSection {
        .startBtn,
        .viewScoreBtn {
          background-color: #1d9dae;
          color: white;
          padding: 5px 20px;
          border-radius: 15px;
          cursor: pointer;
        }
        .viewScoreBtn {
          background-color: #ffffff;
          color: #1d9dae;
          border: 1px solid #1d9dae;
        }
      }
      .posts {
        .post {
          border: 1px solid #cecece;
          border-radius: 10px;
          margin-bottom: 0.5rem;
          .headerSection {
            .subject {
              font-size: 0.95rem;
              font-weight: bold;
              color: #00634b;
            }
            .time {
              color: #3d3d3d;
              font-size: 0.9rem;
            }
          }
          .content {
            color: #707070;
          }
          .file {
            img {
              width: 1rem;
            }
            a {
              color: #006e7f;
            }
          }
          .answer {
            img {
              cursor: pointer;
              width: 1.35rem;
            }
          }
          .replySection {
            .answer {
              textarea {
                resize: none;
                width: 100%;
                height: 10vh;
                border: 1px solid #1d9dae;
                border-radius: 7px;
                -webkit-transition: all 1s -0.25s ease-out;
                -moz-transition: all 1s -0.25s ease-out;
                -o-transition: all 1s -0.25s ease-out;
                -ms-transition: all 1s -0.25s ease-out;
                transition: all 1s -0.25s ease-out;
                z-index: 999;
                &:focus {
                  outline: none;
                  -webkit-transition: all 1s ease;
                  -moz-transition: all 1s ease;
                  -o-transition: all 1s ease;
                  -ms-transition: all 1s ease;
                  transition: all 1s ease;
                }
              }
              .answerSection {
                .answerBtn {
                  background-color: #1d9dae;
                  color: white;
                  border-radius: 15px;
                  font-weight: bold;
                  padding: 0px 20px 3px 20px;
                  cursor: pointer;
                }
              }
              .fileList {
                height: 30px;
                width: 100%;
                flex-wrap: wrap;
                overflow: auto;
                .fileList-item {
                  .close-btn {
                    font-size: 20px;
                    font-weight: bold;
                    color: #eb0404;
                    cursor: pointer;
                  }
                }
              }
            }
          }
        }
      }
    }
    .task-class {
      position: relative;
      padding: 0 10px;
      height: 100%;
      flex-direction: column;
      .lesson-class-icon {
        width: 160px;
      }
    }
    .spinner {
      width: 100%;
      height: 47vh;
    }
  }
}
@media (max-width: 767px) {
  .my-lessons {
    padding: 0;
    .calendarBox {
      .calendar {
        flex: 0 0 100% !important;
        max-width: 100% !important;
        .description {
          .post {
            .headerSection {
              .subject {
                font-size: 0.7rem;
              }
              .time {
                font-size: 0.7rem;
              }
            }
            .answer {
              .answerSection {
                .answerBtn {
                  padding: 3px 20px 2px 20px;
                }
              }
            }
          }
        }
        .posts {
          .post {
            .headerSection {
              .subject-time {
                .subject {
                  font-size: 0.7rem;
                }
                .time {
                  font-size: 0.7rem;
                }
              }
            }
          }
        }
        .content {
          .activities {
            min-height: 45vh;
          }
        }
      }
      .task-class {
        display: none;
      }
      .spinner {
        height: 66vh;
      }
    }
  }
}
</style>